import z from 'zod';
import { BroadcastAudienceType, BroadcastType } from '@trnsact/trnsact-shared-types';

export const broadcastAttachmentSchema = z.object({
  broadcastAttachmentId: z.string().uuid().optional(),
  name: z.string(),
  source: z.string().optional(),
});

export const broadcastSchema = z
  .object({
    type: z.nativeEnum(BroadcastType),
    title: z.string().min(1, 'Title is required'),
    body: z.string().min(1, 'Summary is required'),
    effectiveDateTime: z.any(),
    attachments: z.array(broadcastAttachmentSchema),
    isGlobal: z.boolean().default(false),
    audienceType: z.nativeEnum(BroadcastAudienceType).optional(),
  })
  .superRefine((val, ctx) => {
    if (val.isGlobal && !val.audienceType) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'audienceType is required for global broadcasts',
        path: ['audienceType'],
      });
    }
  });
